import { Injectable } from '@angular/core';
import { GestureController, type GestureDetail } from '@ionic/angular';
import { GestureCallback } from '@ionic/core/dist/types/utils/gesture';
import type { Gesture } from '@ionic/core';

@Injectable({ providedIn: 'root' })
export class GestureService {
  constructor(private gestureCtrl: GestureController) {}

  createHorizontalSwipeGesture(
    node: Node,
    previousCallback: (detail: GestureDetail) => any,
    nextCallback: (detail: GestureDetail) => any
  ): Gesture {
    return this.gestureCtrl.create({
      el: node,
      direction: 'x',
      onEnd: (detail: GestureDetail) => this.onEndClick(detail, previousCallback, nextCallback),
      gestureName: 'swipe',
    });
  }

  private onEndClick(
    detail: GestureDetail,
    previousCallback: (detail: GestureDetail) => any,
    nextCallback: (detail: GestureDetail) => any
  ) {
    const minimumSwipeDeltaX = 50;
    if (detail.deltaX > minimumSwipeDeltaX) {
      previousCallback(detail);
    }
    if (detail.deltaX < -minimumSwipeDeltaX) {
      nextCallback(detail);
    }
  }
}
